import { MaterialInfo } from "../Material";

//CLF Baselines 2023
export const CLFBaselines: MaterialInfo[] = [
  {
    guid: "42e5dcfe-973d-4e61-aed3-0cd36d359e7c",
    name: "Concrete (National) 4000psi",
    category: "03 Concrete",
    source: "CLF",
    gwp: 308,
    units: "m3",
    density: 0,
    transparent: false,
    notes: "2023 CLF US National baseline"
  },
  {
    guid: "6ca00d2b-432a-4bf2-83e8-d76a502235bb",
    name: "Concrete (National) 4000psi + 100kg/m3 rebar",
    category: "03 Concrete",
    source: "CLF",
    gwp: 393,
    units: "m3",
    density: 0,
    transparent: false,
    notes: "2023 CLF US National baseline + 100kg/m3 fabricated rebar"
  },
  {
    guid: "3ef4bcc1-8e82-4250-9ae3-01216a584c4a",
    name: "Concrete (National) 4000psi + 150kg/m3 rebar",
    category: "03 Concrete",
    source: "CLF",
    gwp: 436,
    units: "m3",
    density: 0,
    transparent: false,
    notes: "2023 CLF US National baseline + 150kg/m3 fabricated rebar"
  },
  {
    guid: "b1fa5f05-1098-4903-ac04-9fef3d6956da",
    name: "Concrete (National) 4000psi + 75kg/m3 rebar",
    category: "03 Concrete",
    source: "CLF",
    gwp: 372,
    units: "m3",
    density: 0,
    transparent: false,
    notes: "2023 CLF US National baseline + 75kg/m3 fabricated rebar"
  },
  {
    guid: "1b4762c6-a255-4eba-8c66-b29b1fae5001",
    name: "Concrete (National) 6000psi",
    category: "03 Concrete",
    source: "CLF",
    gwp: 385,
    units: "m3",
    density: 0,
    transparent: false,
    notes: "2023 CLF US National baseline"
  },
  {
    guid: "abfa47ab-9743-4213-b776-59aad8c1f5b0",
    name: "Concrete (National) 6000psi + 100kg/m3 rebar",
    category: "03 Concrete",
    source: "CLF",
    gwp: 470,
    units: "m3",
    density: 0,
    transparent: false,
    notes: "2023 CLF US National baseline + 100kg/m3 fabricated rebar"
  },
  {
    guid: "4f831328-6aa3-4ebf-8168-adc970139867",
    name: "Concrete (National) 6000psi + 150kg/m3 rebar",
    category: "03 Concrete",
    source: "CLF",
    gwp: 513,
    units: "m3",
    density: 0,
    transparent: false,
    notes: "2023 CLF US National baseline + 150kg/m3 fabricated rebar"
  },
  {
    guid: "20c26af0-83cd-4220-ab56-91b893d8d2cd",
    name: "Concrete (National) 6000psi + 75kg/m3 rebar",
    category: "03 Concrete",
    source: "CLF",
    gwp: 449,
    units: "m3",
    density: 0,
    transparent: false,
    notes: "2023 CLF US National baseline + 75kg/m3 fabricated rebar"
  },
  {
    guid: '737b4a66-4213-4e75-b5c2-3114b6e04028',
    name: 'Steel Rebar',
    category: '03 Concrete',
    source: 'CLF',
    gwp: 0.854,
    units: 'kg',
    density: 490,
    transparent: false,
    notes: 'Fabricated Rebar, Density for calculation: 490lb/ft3 or 7849kg/m3'
  },
  {
    guid: '8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8',
    name: 'Cold-formed Steel Framing',
    category: '05 Metals',
    source: 'CLF',
    gwp: 2.440,
    units: 'kg',
    density: 490,
    transparent: false,
    notes: 'Density for calculation: 490lb/ft3 or 7849kg/m3'
  },
  {
    guid: 'c6ba4bd0-78bf-4b8a-abb1-7b464a171bec',
    name: 'Steel Hollow Structural Section',
    category: '05 Metals',
    source: 'CLF',
    gwp: 1.990,
    units: 'kg',
    density: 490,
    transparent: false,
    notes: 'Fabricated HSS, Density for calculation: 490lb/ft3 or 7849kg/m3'
  },
  {
    guid: '6767dd0c-c653-4ea4-b24a-c2a47a499f22',
    name: 'Steel Hot-Rolled Section',
    category: '05 Metals',
    source: 'CLF',
    gwp: 1.080,
    units: 'kg',
    density: 490,
    transparent: false,
    notes: 'Fabricated Hot-Rolled Sections, Density for calculation: 490lb/ft3 or 7849kg/m3'
  },
  {
    guid: '8bde83b5-dc00-4033-9ed9-2d7fe5187c82',
    name: 'Steel Plate',
    category: '05 Metals',
    source: 'CLF',
    gwp: 1.730,
    units: 'kg',
    density: 490,
    transparent: false,
    notes: 'Fabricated Plate, Density for calculation: 490lb/ft3 or 7849kg/m3'
  },
  {
    guid: '04409462-8d84-42f6-b996-233f59673a9c',
    name: 'Steel Decking',
    category: '05 Metals',
    source: 'CLF',
    gwp: 2.330,
    units: 'kg',
    density: 490,
    transparent: false,
    notes: 'Density for calculation: 490lb/ft3 or 7849kg/m3'
  },
  {
    guid: 'e7079c05-e5c1-4c2e-a274-9d1fac27463f',
    name: 'Wood Framing',
    category: '06 Wood & Plastic',
    source: 'CLF',
    gwp: 63.1,
    units: 'm3',
    density: 0,
    transparent: false,
    notes: 'Dimensional softwood framing lumber, generally excludes decking lumber (e.g., redwood)'
  },
  {
    guid: '03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4',
    name: 'Laminated Veneer Lumber (LVL)',
    category: '06 Wood & Plastic',
    source: 'CLF',
    gwp: 361,
    units: 'm3',
    density: 0,
    transparent: false,
    notes: 'Includes LVL of different sizes, structural capacity, and structural applications'
  },
  {
    guid: 'be2bc758-b03e-499b-a1e7-7a4e805a177e',
    name: 'Laminated Strand Lumber (LSL)',
    category: '06 Wood & Plastic',
    source: 'CLF',
    gwp: 275,
    units: 'm3',
    density: 0,
    transparent: false,
    notes: 'Includes LSL of different sizes, structural capacity, and structural applications'
  },
  {
    guid: '30feb4d7-96d0-4ca1-9b89-d50059173436',
    name: 'Plywood',
    category: '06 Wood & Plastic',
    source: 'CLF',
    gwp: 219,
    units: 'm3',
    density: 0,
    transparent: false,
    notes: 'Includes all thicknesses of softwood plywood'
  },
  {
    guid: 'e6f45084-1283-4410-800e-42db211c3a64',
    name: 'Oriented Strand Board (OSB)',
    category: '06 Wood & Plastic',
    source: 'CLF',
    gwp: 243,
    units: 'm3',
    density: 0,
    transparent: false,
    notes: 'Includes all thicknesses of oriented strand board'
  },
  {
    guid: '59c7e7b9-30b8-4a06-b3c8-7e2462921cf7',
    name: 'Glue Laminated Timber (GLT)',
    category: '06 Wood & Plastic',
    source: 'CLF',
    gwp: 137,
    units: 'm3',
    density: 0,
    transparent: false,
    notes: 'Includes GLT products of different shapes, sizes, and configurations'
  },
  {
    guid: 'f363eefa-187b-4e29-906a-731913d10f73',
    name: 'Cross Laminated Timber (CLT)',
    category: '06 Wood & Plastic',
    source: 'CLF',
    gwp: 134,
    units: 'm3',
    density: 0,
    transparent: false,
    notes: 'Collection of CLT product EPDs, unweighted average.'
  },
  {
    guid: 'c202ca66-626d-4304-aba6-a7c2c03a10f3',
    name: 'Mass Ply Panel (MPP)',
    category: '06 Wood & Plastic',
    source: 'CLF',
    gwp: 259,
    units: 'm3',
    density: 0,
    transparent: false,
    notes: 'MPP product EPD (Freres Lumber Company, 2020).'
  },
  {
    guid: '5f6f2bb9-131d-40d4-82a4-21b47e996ad1',
    name: 'Dowel Laminated Timber (DLT)',
    category: '06 Wood & Plastic',
    source: 'CLF',
    gwp: 121,
    units: 'm3',
    density: 0,
    transparent: false,
    notes: 'DLT product EPD (StructureCraft, 2020).'
  },
  {
    guid: 'f88c011a-99c9-43a6-82bb-5aed2c3af067',
    name: 'Wood I-Joists',
    category: '06 Wood & Plastic',
    source: 'CLF',
    gwp: 328.33,
    units: 'm3',
    density: 0,
    transparent: false,
    notes: 'CLF value 1.97 kgCO2e/m is extrapolated to volume units via 1 meter of 1 3/4\" x 11 7/8\" I-Joist.'
  },
  {
    guid: '4b3d3510-f27e-478e-9f85-ad64b15d6725',
    name: 'Sheathing - Glass Mat Gypsum',
    category: '07 Thermal & Moisture Protection',
    source: 'CLF',
    gwp:370,
    units: 'm3',
    density: 0,
    transparent: false,
    notes: 'Values of kgCO2e/m3 are extrapolated from CLF data provided 437 kgCO2e/1000ft2 of 1/2"(12.7mm) thick material.'
  },
  {
    guid: '7d42b06e-a817-4f3a-abef-940f64fd3f90',
    name: 'Metal Panel - Steel',
    category: '07 Thermal & Moisture Protection',
    source: 'CLF',
    gwp: 15.30,
    units: 'm2',
    density: 0,
    transparent: false,
    notes: 'Roll-formed steel cladding panel such as standing seam or box rib; includes products of various thickness and coating options.'
  },
  {
    guid: '6af76ad8-0c27-4d20-b8db-e9cb9a50f6d4',
    name: 'Metal Panel - Aluminum',
    category: '07 Thermal & Moisture Protection',
    source: 'CLF',
    gwp: 18.60,
    units: 'm2',
    density: 0,
    transparent: false,
    notes: 'Roll-formed aluminum cladding panel such as standing seam or box rib; includes products of various thickness and coating options.'
  },
  {
    guid: 'd84358a0-f1c1-4c58-ae7d-c68d03af7425',
    name: 'Metal Panel - Metal Composite Material',
    category: '07 Thermal & Moisture Protection',
    source: 'CLF',
    gwp: 28.00,
    units: 'm2',
    density: 0,
    transparent: false,
    notes: 'Metal Composite Material (MCM) Sandwich panel composed of metal skins and thin polyethylene or fire-resistant core.'
  },
  {
    guid: 'fe787320-24da-40ea-9625-2dea5accb725',
    name: 'Insulation Blanket - Mineral Wool',
    category: '07 Thermal & Moisture Protection',
    source: 'CLF',
    gwp: 78,
    units: 'm3',
    density: 0,
    transparent: false,
    notes: 'Flexible insulating mineral wool (natural rock and/or slag fibers) batts, rolls, or light-density boards. Values extrapolated from CLF data 2.68 with assumed 0.74 Rsi/inch of thickness.'
  },
  {
    guid: 'd7dc207c-4cda-44b6-a2c0-067df911cb0b',
    name: 'Insulation Board - Mineral Wool',
    category: '07 Thermal & Moisture Protection',
    source: 'CLF',
    gwp: 203,
    units: 'm3',
    density: 0,
    transparent: false,
    notes: 'Semi-rigid mineral wool (natural rock and/or slag fibers) board insulation. Values extrapolated from CLF data 6.82with assumed 0.76 Rsi/inch of thickness.'
  },
  {
    guid: 'f4bad51d-d360-4afa-9c26-4f8c26bb7569',
    name: 'Insulation Board - Fiberglass',
    category: '07 Thermal & Moisture Protection',
    source: 'CLF',
    gwp: 150,
    units: 'm3',
    density: 0,
    transparent: false,
    notes: 'Value extrapolated from CLF data 5.02 with assumed 0.76 Rsi/inch of thickness.'
  },
  {
    guid: 'a16e5185-3d51-4c40-8cf3-b30619c3dc03',
    name: 'Insulation Board - XPS R5/in',
    category: '07 Thermal & Moisture Protection',
    source: 'CLF',
    gwp: 309,
    units: 'm3',
    density: 0,
    transparent: false,
    notes: 'Extruded polystyrene closed-cell foam board insulation 25psi; XPS product EPD (Owens Corning, 2024). Includes modules A1–A3, B1, and C4 to account for blowing agent emissions. Values extrapolated from CLF data 8.9 with assumed 0.88 Rsi/inch of thickness.'
  },
  {
    guid: '8c243bcb-462e-44c1-8a50-86d28048784e',
    name: 'Insulation Board - EPS R4/in',
    category: '07 Thermal & Moisture Protection',
    source: 'CLF',
    gwp:74,
    units: 'm3',
    density: 0,
    transparent: false,
    notes: 'EPS Type I closed-cell rigid foam board insulation. Values extrapolated from CLF data 2.53with assumed 0.74 Rsi/inch of thickness.'
  },
  {
    guid: '8ae703c3-3f14-4a56-999c-affb03642e1a',
    name: 'Insulation Board - Polyiso Wall R6/in',
    category: '07 Thermal & Moisture Protection',
    source: 'CLF',
    gwp: 146,
    units: 'm3',
    density: 0,
    transparent: false,
    notes: 'Polyisocyanurate closed-cell rigid foam board for wall applications with glass-reinforced aluminum foil facers. Values extrapolated from CLF data 3.5 with assumed 1.06 Rsi/inch of thickness.'
  },
  {
    guid: '957991f3-a237-47db-8329-7cd7e2fc514e',
    name: 'Insulation Board - Polyiso Roof GRF R6/in',
    category: '07 Thermal & Moisture Protection',
    source: 'CLF',
    gwp: 88,
    units: 'm3',
    density: 0,
    transparent: false,
    notes: 'Polyisocyanurate closed-cell rigid foam board for roof applications with GRF glass-fiber-reinforced cellulosic facers. Values extrapolated from CLF data 2.11 with assumed 1.06 Rsi/inch of thickness.'
  },
  {
    guid: '618a0f38-0d08-4b8f-9712-d3128f147a8d',
    name: 'Insulation Board - Polyiso Roof CFG R6/in',
    category: '07 Thermal & Moisture Protection',
    source: 'CLF',
    gwp: 123,
    units: 'm3',
    density: 0,
    transparent: false,
    notes: 'Polyisocyanurate closed-cell rigid foam board for roof applications with CFG polymer-bonded coated glass facers. Values extrapolated from CLF data 2.95 with assumed 1.06 Rsi/inch of thickness.'
  },
  {
    guid: '5ba4d1b3-a13b-41bd-a93b-b8a5276196e6',
    name: 'Insulation Foam - Closed Cell Polyurethane R7/in',
    category: '07 Thermal & Moisture Protection',
    source: 'CLF',
    gwp: 128,
    units: 'm3',
    density: 0,
    transparent: false,
    notes: 'Medium density closed-cell SPF, typ 1.5-2.5 pcf (24-40 kg/m3), HFC or HFO blowing agent. Values extrapolated from CLF data 2.63with assumed 1.23 Rsi/inch of thickness.'
  },
  {
    guid: '0cd12f49-bbc5-4c59-9e90-2794cb24ecfb',
    name: 'Insulation Foam - Open Cell Polyurethane R4/in',
    category: '07 Thermal & Moisture Protection',
    source: 'CLF',
    gwp: 32,
    units: 'm3',
    density: 0,
    transparent: false,
    notes: 'Open-cell SPF using reactive blowing agent (water). Values extrapolated from CLF data 1.17 with assumed 0.70 Rsi/inch of thickness.'
  },
  {
    guid: 'bbc6adeb-3583-42f0-a3c9-a927068c2450',
    name: 'Insulation Loose Fill - Cellulose R3.5/in',
    category: '07 Thermal & Moisture Protection',
    source: 'CLF',
    gwp: 12,
    units: 'm3',
    density: 0,
    transparent: false,
    notes: 'Cellulose unbonded loose-fill insulation. Values extrapolated from CLF data with assumed 0.62 Rsi/inch of thickness.'
  },
  {
    guid: '97b3c007-3678-4241-b523-7c618b3a77dd',
    name: 'Insulation Loose Fill - Mineral Wool R3/in',
    category: '07 Thermal & Moisture Protection',
    source: 'CLF',
    gwp: 39,
    units: 'm3',
    density: 0,
    transparent: false,
    notes: 'Cellulose unbonded loose-fill insulation. Values extrapolated from CLF data 1.89 with assumed 0.62 Rsi/inch of thickness.'
  },
  {
    guid: 'c18457b5-027c-4a36-8baa-983fc21955d8',
    name: 'Spray-applied Fireproofing',
    category: '07 Thermal & Moisture Protection',
    source: 'CLF',
    gwp: 0.749,
    units: 'kg',
    density: 30,
    transparent: false,
    notes: 'Medium Density (30lb/ft3). Collection of applied fireproofing product EPDs, unweighted average.'
  },
  {
    guid: 'c024c2bc-e046-41ef-8736-c0bdb61848d5',
    name: 'Flat Glass',
    category: '08 Openings',
    source: 'CLF',
    gwp: 1.430,
    units: 'kg',
    density: 158,
    transparent: true,
    notes: 'Clear, low-iron, and tinted glass products that have been manufactured in an unprocessed annealed state. Density for calculations: 158lb/ft3 or 2531kg/m3'
  },
  {
    guid: 'dea0b930-4ad4-4592-b9fc-a83ec7d740b5',
    name: 'Aluminum Extrusion',
    category: '08 Openings',
    source: 'CLF',
    gwp: 10.300,
    units: 'kg',
    density: 169,
    transparent: false,
    notes: 'Standard (non-thermally-improved) extrusions with mill finish (no additional surface treatment). Density for calculation: 169lb/ft3 or 2700kg/m3'
  },
  {
    guid: '415e61a8-adc0-486b-a41d-2f3d66f23404',
    name: 'Aluminum Extrusion Painted',
    category: '08 Openings',
    source: 'CLF',
    gwp: 11.700,
    units: 'kg',
    density: 169,
    transparent: false,
    notes: 'Standard (non-thermally-improved) extrusions with paint finish. Density for calculation: 169lb/ft3 or 2700kg/m3'
  },
  {
    guid: 'be070326-14ed-4a23-837f-720e3a806952',
    name: 'Aluminum Extrusion Anodized',
    category: '08 Openings',
    source: 'CLF',
    gwp: 10.800,
    units: 'kg',
    density: 169,
    transparent: false,
    notes: 'Standard (non-thermally-improved) extrusions with anodized finish. Density for calculation: 169lb/ft3 or 2700kg/m3'
  },
  {
    guid: '3c5b5190-9f20-4456-a64d-5c06351950c2',
    name: 'Aluminum Extrusion Thermally Improved - Paint Finish',
    category: '08 Openings',
    source: 'CLF',
    gwp: 12.700,
    units: 'kg',
    density: 169,
    transparent: false,
    notes: 'Thermally-improved extrusions for exterior envelope assemblies (e.g., curtain wall, storefront, etc.) with paint finish. Density for calculation: 169lb/ft3 or 2700kg/m3'
  },
  {
    guid: '843ad0aa-7ef8-4498-a2af-fd73bdd6fb8c',
    name: 'Aluminum Extrusion Thermally Improved - Anodized Finish',
    category: '08 Openings',
    source: 'CLF',
    gwp: 11.800,
    units: 'kg',
    density: 169,
    transparent: false,
    notes: 'Thermally-improved extrusions for exterior envelope assemblies (e.g., curtain wall, storefront, etc.) with anodized finish. Density for calculation: 169lb/ft3 or 2700kg/m3'
  },
  {
    guid: '1b3f5a87-a2dd-45db-a3d0-812ed2645708',
    name: 'Gypsum Board Finish',
    category: '09 Finishes',
    source: 'CLF',
    gwp: 188,
    units: 'm3',
    density: 0,
    transparent: false,
    notes: 'Values of kgCO2e/m3 are extrapolated from CLF data provided in kgCO2e/1000ft2 of 5/8"(15.9mm) thick Type X material.'
  },
]